import PropTypes from 'prop-types';
import React from 'react';
import CONST from '../const';

import connect from './connect';
import { selectContent } from '../selectors/content';
import Dialog from './dialog.jsx';
import { routeToTerm } from '../actions/route';

class AnalyticsDialog extends React.Component {
    static displayName = 'AnalyticsDialog';

    state = { howToUseOpen: false };

    toggleHowToUse = () => {
        this.setState(s => ({ howToUseOpen: !s.howToUseOpen }));
    };

    static propTypes = {
        contentId: PropTypes.string,
        content: PropTypes.shape({
            section_id: PropTypes.number.isRequired,
            slug: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
        }),
        routeToTerm: PropTypes.func.isRequired,
        term: PropTypes.shape({
            id: PropTypes.number,
        }).isRequired,
    };

    onClose = () => {
        this.props.routeToTerm({ termId: this.props.term.id });
    };

    buildUrl(content) {
        const url = `${CONST.ANALYTICS.URL}reading`;
        const params = [`?content_id=${encodeURIComponent(content.id)}`];
        return url + params.join('&');
    }

    render() {
        const { content } = this.props;
        if (!content) {
            return null;
        }

        const url = this.buildUrl(content);
        const iframeTitle = `Analytics for ${content.title}`;

        return (
            <Dialog
                className="modal-fullscreen"
                key={url}
                buttons={[]}
                closeButton
                onClose={this.onClose}
                title={content.title}
            >
                <div style={{ margin: '0px 50px' }}>
                    <button
                        aria-expanded={this.state.howToUseOpen}
                        aria-controls="how-to-use-content"
                        onClick={this.toggleHowToUse}
                        style={{ fontSize: '16px' }}
                        className="btn"
                    >
                        HOW TO USE
                    </button>
                    <div
                        id="how-to-use-content"
                        hidden={!this.state.howToUseOpen}
                        style={{ margin: '0px 50px' }}
                    >
                        <p>
                            Use this chart to view a section's page reads. A
                            page read is counted when a student is on a page for
                            10 or more seconds. Hover over any page read on the
                            graph to get the exact page a read event took place.
                        </p>
                        <ul
                            style={{
                                listStyleType: 'circle',
                                padding: 'revert',
                            }}
                        >
                            <li>
                                The edges of the graph are determined by the
                                earliest and furthest pages read by any student
                                in the section.
                            </li>
                            <li>
                                The darker the blue on a page read, the longer
                                the student was on said page.
                            </li>
                        </ul>
                        <p>
                            Click on any student's name to drill down into their
                            page reads and see specific dates that read events
                            were tracked on.
                        </p>
                        <p>
                            Click the "Export" button when viewing the section
                            to create a csv template of the page reads for the
                            entire section.
                        </p>
                        <p>
                            Click the "Export" button when viewing a student to
                            create a csv template of the page reads for that
                            individual student.
                        </p>
                        <p>The data shown on this graph is updated hourly.</p>
                        <p>
                            <strong>NOTE:</strong> the columns labeled "index"
                            on the export have been separated as they DO NOT
                            correlate with page numbers as a user might expect.
                            These columns are necessary to populate the graph,
                            but are not expected to be used by faculty.
                        </p>
                    </div>
                </div>
                <div style={{ margin: '0px 50px' }}>
                    <i>Please note: this product is still in its beta phase.</i>
                </div>
                <div className="analytics-preview">
                    <iframe src={url} title={iframeTitle} />
                </div>
            </Dialog>
        );
    }
}

const mapStateToProps = (state, props) => ({
    content: selectContent(state, props.params.contentId),
});

export default connect(mapStateToProps, {
    routeToTerm,
})(AnalyticsDialog);



// WEBPACK FOOTER //
// ./src/components/analytics_dialog.jsx